import React from "react";
import { Box, styled } from "@mui/material";



const Footer = styled(Box)({
  textAlign: "center",
  position: "relative",
});

export const MainFooter = ({ children }: { children?: React.ReactNode }) => {
  return (
    <Footer>
      {children}
    </Footer>
  );
};
